<template>
    <dl class="accordion box" role="presentation">
        <TotemAccordionItem
            v-for="item in content"
            :multiple="multiple"
            :item="item"
            :groupId="groupId"
            :key="item.id"
            :isActive="activeItem === item.id"
            @setActive="switchItem"
            theme="order-history"
        >
            <template #header>
                <OrderRow :label="$t('OrderAccordion.packages')" :data="item.packages" />
                <OrderRow :label="$t('OrderAccordion.date')" :data="item.date" />
            </template>

            <template #content>
                <OrderRow v-for="(detail, index) in item.details" :label="detail.label" :data="detail.data"
                          :key="index" />
            </template>
        </TotemAccordionItem>
    </dl>
</template>

<script>
    import OrderRow from 'components/user/orderinfo/OrderRow'
    import switchItem from 'components/shared/mixins/accordionSwitchItem'

    export default {
        components: {
            OrderRow
        },
        props: {
            content: {
                type: Array,
                required: true
            }
        },
        mixins: [ switchItem ],
        mounted () {
            this.groupId = this.$el.id
        },
        data () {
            return {
                groupId: null,
                activeItem: 1,
                multiple: false
            }
        }
    }
</script>
